import { RegistryBannerVariant } from 'baby-ui/lib/RegistryBannerVariant'
import { BannerProportion } from 'baby-ui/compounds/RegistryBanner/BannerProportion'
import { useFeature } from 'flagged'
import { ChecklistCategoryBreastPumpBanner } from './ChecklistCategoryBreastPumpBanner'
import { SearchBreastPumpBanner } from './SearchBreastPumpBanner'
import {
  FREE_GIFT_FLAG,
  SEARCH_SUGGESTIONS_FLAG,
  SHOW_HEALTH_REGISTRY_BANNERS_FLAG,
} from './RegistryBanner.constants'
import { RegistryBannerEvents } from './RegistryBannerEvents'

export interface ChecklistCategoryBannerProps extends RegistryBannerEvents {
  query?: string
  variant: RegistryBannerVariant | null
}

export const RegistryBanner = ({
  query = '',
  variant,
  ...rest
}: ChecklistCategoryBannerProps) => {
  const shouldShowSearchSuggestionBanner = useFeature(SEARCH_SUGGESTIONS_FLAG)
  const showFreeGiftText = useFeature(FREE_GIFT_FLAG) as boolean
  const showHealthRegistryBanners = useFeature(
    SHOW_HEALTH_REGISTRY_BANNERS_FLAG
  )

  if (!showHealthRegistryBanners) return null

  switch (variant) {
    case RegistryBannerVariant.ChecklistBreastPumpBanner:
      return (
        <ChecklistCategoryBreastPumpBanner
          showFreeGiftText={showFreeGiftText}
          {...rest}
        />
      )
    case RegistryBannerVariant.SearchResultBreastPumpBanner:
      return (
        <SearchBreastPumpBanner
          proportion={BannerProportion.Spacious}
          query={query}
          showFreeGiftText={showFreeGiftText}
          {...rest}
        />
      )
    case RegistryBannerVariant.SearchSuggestionBreastPumpBanner:
      return shouldShowSearchSuggestionBanner ? (
        <SearchBreastPumpBanner
          proportion={BannerProportion.Compact}
          query={query}
          showFreeGiftText={showFreeGiftText}
          {...rest}
        />
      ) : null
    default:
      return null
  }
}
